export const color = {
  sma: {
    0: '#e0685e',
    1: '#ff9a03',
    2: '#8e601b',
    3: '#904a4a',
    4: '#3c9660',
    5: '#6fbc59',
    6: '#334db6',
    7: '#5974e2',
    8: '#3bb3e4',
    9: '#754dcb',
    10: '#bc48cf',
    11: '#ff4ac2',
    12: '#222',
    13: '#999',
    14: '#bbb',
  },
}
